const ContractErrorMap: Record<string, string> = {
  "User rejected the request": "toast.chainError.userRejected",
  ECDSAInvalidSignature: "toast.chainError.ECDSAInvalidSignature",
  TokenNotSupported: "toast.chainError.tokenNotSupported",
  InvalidRecipient: "toast.chainError.invalidRecipient",
};
const ContractErrorKeys = Object.keys(ContractErrorMap);

/**
 * 将链上交互错误解析为 i18n key（`toast.chainError.*`，见各语言 `locales/*.json`）。
 *
 * 展示：`toast.error(i18next.t(parseChainError(err)))`
 * @param error 原始错误（viem/wagmi 抛出的 Error 等）
 * @param fallbackKey 无法归类时的 key，默认 `toast.chainError.transactionError`
 */
export function parseChainError(
  error: unknown,
  fallbackKey = "toast.chainError.transactionError"
): string {
  try {
    if (!error) {
      return fallbackKey;
    }
    // 检查错误对象
    if (error && typeof error === "object" && "name" in (error as any)) {
      const name = (error as any).name;
      switch (name) {
        case "UserRejectedRequestError":
          return "toast.chainError.userRejected";
        case "ContractFunctionExecutionError": {
          const shortMessage = (error as any)?.message || "";
          // 余额不足
          if (
            shortMessage.includes("insufficient funds") ||
            shortMessage.includes("exceeds the balance") ||
            shortMessage.includes("insufficient balance")
          ) {
            return "toast.chainError.insufficientBalance";
          }
          const matched = ContractErrorKeys.find(key =>
            shortMessage.includes(key)
          );
          if (matched) return ContractErrorMap[matched];
          return "toast.chainError.contractExecution";
        }
        case "TransactionExecutionError":
          return "toast.chainError.transactionExecution";
        default: {
          return fallbackKey;
        }
      }
    }

    // 如果错误是字符串，检查是否包含特定关键词
    if (typeof error === "string") {
      const lowerError = error.toLowerCase();
      if (
        lowerError.includes("user rejected") ||
        lowerError.includes("user denied")
      ) {
        return "toast.chainError.userRejected";
      }
      if (
        lowerError.includes("insufficient") ||
        lowerError.includes("balance")
      ) {
        return "toast.chainError.insufficientBalance";
      }
    }

    return fallbackKey;
  } catch (e) {
    return fallbackKey;
  }
}
